import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';

export const Route = createFileRoute('/_authenticated/super-admin')({
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    if (session.user.role !== 'super_admin') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: SuperAdminLayout,
});

function SuperAdminLayout() {
  return <Outlet />;
}
